export default (amount) => {
	let i = 0, texte = String(amount).split("").reverse().join(''), ouput = "";

	while (i < texte.length) {
		i % 3 === 0 ? ouput += ' ' + texte.charAt(i) : ouput += texte.charAt(i);
		i++;
	}

	return ouput.split('').reverse().join('');
};